export async function createSmartValuesUseCase(customer_id, values, customerRepostitory) {
    const result = await customerRepostitory.create_smart_values(customer_id, values);

    return result;
}